import {
    get,
    post
} from '../utils/request';

/**
 * 获取列表
 * @param {pageNo} 
 * @param {pageNo} 
 * @param {type}  类型 1运动员 2教练 3 裁判
 */
export const list = params=>get("/registerDate/list",params);

/**
 * 新增/修改
 * @param {endDate} 
 * @param {startDate}
 * @param {id}
 * @param {type}  类型 1运动员 2教练 3 裁判
 */
export const saveDate = params=>post("/registerDate/save",params);

/**
 * 是否可以注册
 * @param {type}  类型 1运动员 2教练 3 裁判
 */
export const isRegist = params=>get('/registerDate/isRegister',params);

/**
 * 修改状态
 * @param {state} 
 */
export const updateStates = params =>post('/registerDate/updateState',params);